module.exports = __webpack_public_path__ + "img/golf-flag-hole.f7b2b20d.svg";